<div *ngIf="offerIsVisible">
  <mat-expansion-panel
    hideToggle="true"
    class="option-expansion-panel"
    [expanded]="true"
    [disabled]="!cardExpandable"
  >
    <mat-expansion-panel-header
      [collapsedHeight]="'52px'"
      [expandedHeight]="'52px'"
      class="option-expansion-header"
      data-cy="option-panel"
    >
      <div class="section-container" data-cy="option-header">
        <div class="tw-flex-1 tw-self-start tw-self-center">
          <div class="section-container">
            <div class="tw-self-center" *ngIf="cardExpandable">
              <mat-icon class="expand-icon">{{
                "keyboard_arrow_down"
              }}</mat-icon>
            </div>
            <div class="tw-self-center">
              <span
                class="tw-font-bold squished"
                [ngClass]="{ faded: optionParentLenderName.length > 45 }"
                >{{ optionParentLenderName }}</span
              >
              <span class="tw-font-bold">: {{ option.name }}</span
              ><br />
              <span class="options-header-subtitle">{{
                optionParentName
              }}</span>
            </div>
          </div>
        </div>
        <div class="tw-flex-initial tw-justify-self-end tw-self-center tw-ml-3">
          <div class="preview-container">
            <span
              class="preview-section tw-gap-2 tw-flex tw-items-center tw-justify-end"
              data-cy="option-actions"
            >
              <recommend-option-toggle
                *ngIf="canRecommendOptions"
                [value]="option.isRecommended"
                (change)="recommendedToggleChange($event)"
              ></recommend-option-toggle>
              <span class="tw-font-bold">Status: </span>
              <span class="tw-font-bold status-{{ option.status }} column-inline-grid tw-items-center">
                {{ option.statusLabel }}
                @if(option.status === 'declined' && option.declineReasons?.length) {
                  <app-decline-info-tooltip [declineReasons]="option.declineReasons"></app-decline-info-tooltip>
                }
              </span>
              <offer-option-more-menu
                [option]="option"
                [optionType]="optionType"
                [optionParentName]="optionParentName"
                [hasContractRequest]="hasContractRequest"
                (offerOptionUpdated)="handleOfferOptionUpdated($event)"
              >
              </offer-option-more-menu>
            </span>
          </div>
        </div>
      </div>
    </mat-expansion-panel-header>
    <ng-container *ngTemplateOutlet="matExpansionPanelContent"></ng-container>
  </mat-expansion-panel>
  <ng-template #matExpansionPanelContent>
    <ng-container *ngTemplateOutlet="panelBody"></ng-container>
    <ng-container *ngTemplateOutlet="panelFooter"></ng-container>
  </ng-template>
  <ng-template #panelBody>
    <!-- OFFER BODY -->
    <div class="section-container option-values" data-cy="option-values">
      <div class="grid-section option-section-left">
        <div class="option-value-row">
          <div>
            {{
              optionLoanCategoryType === "loc"
                ? "Initial Draw Amount"
                : "Amount"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.amount"
          >
            {{
              option.termSet.amount
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.initialDrawAmount"
          >
            {{
              option.termSet.initialDrawAmount
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!option.termSet.amount && !option.termSet.initialDrawAmount"
          >
            -
          </div>
        </div>
        <div *ngIf="optionLoanCategoryType === 'ach'" class="option-value-row">
          <div>Payback</div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.payback"
          >
            {{
              option.termSet.payback
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!option.termSet.payback"
          >
            —
          </div>
        </div>
        <div *ngIf="optionLoanCategoryType === 'loc'" class="option-value-row">
          <div>Credit Limit</div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.creditLimit"
          >
            {{
              option.termSet.creditLimit
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!option.termSet.creditLimit"
          >
            —
          </div>
        </div>
        <div class="option-value-row">
          <div>Term</div>
          <div class="option-value-column-value tw-font-bold">
            {{ option.termSet.term ? option.termSet.term + "&nbsp;" : "—" }}
          </div>
          {{
            (option.termSet.term | number : "1.0-0")
              ? termDurationFormatted
              : ""
          }}
        </div>
        <div class="option-value-row">
          <div>Payment Amount</div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.paymentAmount"
          >
            {{
              option.termSet.paymentAmount
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!option.termSet.paymentAmount"
          >
            —
          </div>
        </div>
        <div class="option-value-row">
          <div>Frequency</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.paymentFrequency
                ? (option.termSet.paymentFrequency | titlecase)
                : "—"
            }}
          </div>
        </div>
        <div class="option-value-row">
          <div># of Payments</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.paymentCount
                ? (option.termSet.paymentCount | number : "1.0-0")
                : "—"
            }}
          </div>
        </div>
        <div *ngIf="optionLoanCategoryType === 'ach'" class="option-value-row">
          <div>Factor</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.factorRate
                ? (option.termSet.factorRate | number : "1.2-2")
                : "—"
            }}
          </div>
        </div>
        <div
          *ngIf="
            optionLoanCategoryType !== 'ach' && option.termSet.paymentFrequency
          "
          class="option-value-row"
        >
          <div>{{ option.termSet.paymentFrequency | titlecase }} Rate</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.periodicRate
                ? (option.termSet.periodicRate | number : "1.2-2") + "%"
                : "—"
            }}
          </div>
        </div>
        <div *ngIf="optionLoanCategoryType !== 'ach'" class="option-value-row">
          <div>APR</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.apr
                ? (option.termSet.apr | number : "1.2-2") + "%"
                : "—"
            }}
          </div>
        </div>
      </div>

      <div class="grid-section option-section-right">
        <div class="option-value-row">
          <div>Points</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.points
                ? (option.termSet.points | number : "1.0-0")
                : "—"
            }}
          </div>
        </div>
        <div class="option-value-row">
          <div>Commission</div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.commission"
          >
            {{
              option.termSet.commission
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!option.termSet.commission"
          >
            —
          </div>
        </div>
        <div class="option-value-row">
          <div>
            {{
              optionLoanCategoryType === "loc" ? "Draw Fee" : "Origination Fee"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.originationFeeAmount"
          >
            {{
              option.termSet.originationFeeAmount
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="option.termSet.drawFeeAmount"
          >
            {{
              option.termSet.drawFeeAmount
                | currency : "USD" : "symbol-narrow" : "1.0-0"
            }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="
              !option.termSet.originationFeeAmount &&
              !option.termSet.drawFeeAmount
            "
          >
            -
          </div>
        </div>
        <div *ngIf="optionLoanCategoryType === 'loc'" class="option-value-row">
          <div>Interest Rate</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.annualInterestRate
                ? (option.termSet.annualInterestRate | number : "1.2-2") + "%"
                : "—"
            }}
          </div>
        </div>
        <div class="option-value-row">
          <div>Position</div>
          <div class="option-value-column-value tw-font-bold">
            {{
              option.termSet.position
                ? (option.termSet.position | number : "1.0-0")
                : "—"
            }}
          </div>
        </div>
        <div class="option-value-row">
          <div>Type</div>
          <div class="option-value-column-value tw-font-bold">
            {{ optionParentType ? (optionParentType | titlecase) : "—" }}
          </div>
        </div>
        <div class="option-value-row">
          <div>Date Received</div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="optionCreatedFormatted"
          >
            {{ optionCreatedFormatted | date : "shortDate" }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!optionCreatedFormatted"
          >
            —
          </div>
        </div>
        <div class="option-value-row">
          <div>Expires</div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="parentExpiredFormatted"
          >
            {{ parentExpiredFormatted | date : "shortDate" }}
          </div>
          <div
            class="option-value-column-value tw-font-bold"
            *ngIf="!parentExpiredFormatted"
          >
            —
          </div>
        </div>
      </div>
    </div>

    <div class="benefits">
      <app-value-props-smart [option]="option" optionType="option"></app-value-props-smart>
    </div>
  </ng-template>
  <ng-template #panelFooter>
    <!-- OFFER FOOTER -->
    <div class="offer-footer">
      <div class="section-container">
        <div class="grid-section">
          <span
            class="accept-offer-toggle tw-items-center"
            *ngIf="option.status != 'inactive'"
          >
            Option Accepted?
            <mat-slide-toggle
              data-cy="accept-option-toggle"
              color="primary"
              class="accept-offer-toggle tw-ml-2"
              [checked]="option.status == 'accepted' ? true : false"
              [disabled]="false"
              (change)="acceptedToggleChange($event.checked)"
            >
            </mat-slide-toggle>
          </span>
        </div>
      </div>
    </div>
  </ng-template>
</div>
